import { Directive, Input, Optional } from '@angular/core';
import { AbstractControl, Validator, NG_VALIDATORS, ValidationErrors, NgForm } from '@angular/forms';

@Directive({
    selector: '[startEndTimeValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: StartEndTimeValidatorDirective,
            multi: true,
        },
    ],
})
export class StartEndTimeValidatorDirective implements Validator {
    @Input('startEndTimeValidator')
    secondControlName: string;

    @Input()
    isStartTime: boolean;

    @Input()
    isEndTime: boolean;

    constructor(@Optional() private form: NgForm) {}

    validate(control: AbstractControl<any, any>): ValidationErrors {
        if (!control || !control.value || !this.form || !this.secondControlName) {
            return null;
        }

        // Get the second control from the form by name
        const secondControl: AbstractControl = this.form.form?.get(this.secondControlName);
        if (!secondControl || !secondControl.value) {
            return null;
        }

        if (this.isStartTime) {
            if (control.value >= secondControl.value) {
                return { startEndTimeInvalid: true };
            } else {
                secondControl.setErrors(null);
            }
        }

        if (this.isEndTime) {
            if (control.value <= secondControl.value) {
                return { startEndTimeInvalid: true };
            } else {
                secondControl.setErrors(null);
            }
        }
        return null;
    }
}
